export var IntelligentPhotoCaptureAttachmentIterationStatus;
(function (IntelligentPhotoCaptureAttachmentIterationStatus) {
    IntelligentPhotoCaptureAttachmentIterationStatus["COMPLETED"] = "Completed";
    IntelligentPhotoCaptureAttachmentIterationStatus["IN_PROGRESS"] = "In progress";
    IntelligentPhotoCaptureAttachmentIterationStatus["PENDING"] = "Pending";
})(IntelligentPhotoCaptureAttachmentIterationStatus || (IntelligentPhotoCaptureAttachmentIterationStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureAttachmentIterationStatus.js.map